import React, { Component } from 'react';
import { Text } from 'common-components/typography';
import { connect } from 'react-redux';
import { dispatch, IRootDispatch } from 'stores/rematch/root-store';
import SpinningLoader from 'common-components/loading/SpinningLoader';
import _ from 'lodash';
import FoundWorkerRow from 'views/bookings-v2/components/FoundWorkerRow';
import { LegacyClass } from 'interfaces/helper-types';
import { ActionIcon, Center, Loader, Paper, TextInput } from '@good/ui/core';
import { Search, Cross } from '@good/icons';

interface ISelectWorkerSearchModalProps {
  isOpen: boolean;
  selectedWorker: any;
  bookingId: any;
  startDateTime: any;
  endDateTime: any;
  address: any;
  customerUserIds: Array<string>;
  serviceId: string;
  onCloseSearchModal: () => void;
  selectWorker: (selectedWorker) => void;
  onAssignWorker: (shiftSlotStatus) => void;
  doFetchServiceRoster: typeof dispatch.bookingsStore.doFetchServiceRoster;
  isBookingCancelled: boolean;
  searchInputValue: string;
  onChangeSearchInputValue: (value: string) => void;
}

interface ISelectWorkerSearchModalState {
  isSearching: boolean;
  searchedList: Array<null>;
  searchInputValue: string;
  searchString: string;
  workerNotFound: boolean;
}

class SelectWorkerSearch extends Component<ISelectWorkerSearchModalProps, ISelectWorkerSearchModalState> {
  static defaultProps = {
    isBookingCancelled: false,
  };

  state = {
    isSearching: false,
    searchedList: [],
    searchString: '',
    workerNotFound: false,
  };

  private _searchText = async (txt) => {
    const { startDateTime, endDateTime, address, serviceId, customerUserIds } = this.props;
    const searchedList: any = !_.isEmpty(txt)
      ? await this.props.doFetchServiceRoster({
          startDateTime,
          endDateTime,
          address,
          serviceId,
          customerUserIds,
          searchString: txt,
        })
      : [];
    this.setState({
      isSearching: false,
      searchString: txt,
      searchedList,
      workerNotFound: searchedList && searchedList.length === 0 && !_.isEmpty(txt),
    });
  };

  private _debounceSearch = _.debounce(this._searchText, 500);

  private _onEnterSearchText = (value: string) => {
    this.props.onChangeSearchInputValue(value);
    this.setState({ isSearching: true });
    this.props.selectWorker(null);
    this._debounceSearch(value);
  };

  private _onCloseSearchModal = () => {
    const { onCloseSearchModal, selectWorker } = this.props;
    this.setState({ searchInputValue: '', searchString: '', workerNotFound: false, searchedList: [] });
    selectWorker(null);
    onCloseSearchModal();
  };

  override render() {
    const { selectedWorker, searchInputValue } = this.props;
    const { isSearching, workerNotFound, searchedList } = this.state;

    return (
      <>
        <div className='flex-row justify-between'>
          <TextInput
            w='100%'
            onChange={(e) => this._onEnterSearchText(e.currentTarget.value)}
            leftSection={isSearching ? <Loader size='xs' /> : <Search />}
            placeholder='Search team member'
            value={searchInputValue}
            size='sm'
            rightSection={
              <ActionIcon size='sm' variant='transparent' onClick={() => this._onEnterSearchText('')} c='dimmed'>
                <Cross />
              </ActionIcon>
            }
          />
        </div>
        {searchInputValue && (
          <>
            <Paper withBorder mt='xs'>
              <div style={{ minHeight: '300px', overflow: 'auto', maxHeight: 400 }}>
                {this.state.isSearching && (
                  <Center h={400}>
                    <SpinningLoader size={100} message={'Loading'} />
                  </Center>
                )}
                {_.isEmpty(searchedList) &&
                  !this.state.isSearching &&
                  (!workerNotFound ? (
                    <Center h={400} px='lg'>
                      <div className='text-align-center'>
                        <Text weight='bold'>Enter a Team member name to begin searching</Text>
                        <br />
                        <Text>We’ll search the service roster for matches.</Text>
                      </div>
                    </Center>
                  ) : (
                    <Center h={400} px='lg'>
                      <div className='text-align-center'>
                        <Text weight='bold'>No Team member found</Text>
                        <br />
                        <Text>Try searching for another person.</Text>
                      </div>
                    </Center>
                  ))}
                {searchedList && searchedList.length > 0 && !this.state.isSearching && (
                  <table className='width-full'>
                    <tbody>
                      {_.map(searchedList, (worker) => {
                        return (
                          <FoundWorkerRow
                            worker={worker}
                            isSelected={selectedWorker && worker.supportWorkerId === selectedWorker.supportWorkerId}
                            isSearch={true}
                            selectWorker={this.props.selectWorker}
                          />
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </Paper>
            {/* <div className='flex-row justify-end'>
              <AssignSessionButton
                selectedWorker={selectedWorker}
                isBookingCancelled={isBookingCancelled}
                onAssignWorker={onAssignWorker}
              />
            </div> */}
          </>
        )}
      </>
    );
  }
}

const mapDispatch = (dispatch: IRootDispatch) => ({
  doFetchServiceRoster: dispatch.bookingsStore.doFetchServiceRoster,
});

export default connect(null, mapDispatch)(SelectWorkerSearch) as unknown as LegacyClass<
  ISelectWorkerSearchModalProps,
  never,
  typeof mapDispatch
>;
